:host {
  display: block;
  width: 100%;
}

.rsm-confirm-button-style {
  display: block;
  width: 100%;
  max-width: 400px;
  padding: 1rem 2rem;
  margin: 0 auto;
  font-size: 1rem;
  font-weight: 500;
  background-color: #0066cc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  line-height: 1.5;
  letter-spacing: 0.025rem;
  margin: 0 auto;
}
.rsm-confirm-button-style:hover{
  background-color: #0052a3;
}